/**
 * Demand Momentum Indicator Component
 * Extracted from App.js - Phase 7C Frontend Refactor
 */
import { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";

const DemandMomentumIndicator = () => {
  const { apiFetch } = useAuth();
  const [momentum, setMomentum] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMomentum = async () => {
      try {
        const res = await apiFetch("/demand/momentum?current_period_hours=24", { method: "GET" });
        setMomentum(res.data);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
        setIsLoading(false);
      }
    };
    fetchMomentum();
  }, [apiFetch]);

  if (isLoading || !momentum) return null;

  const getStateIcon = () => {
    switch (momentum.state) {
      case "increasing": return "📈";
      case "decreasing": return "📉";
      default: return "➡️";
    }
  };

  const getStateColor = () => {
    switch (momentum.state) {
      case "increasing": return "#10b981";
      case "decreasing": return "#ef4444";
      default: return "#6b7280";
    }
  };

  return (
    <div className="momentum-indicator" style={{ borderLeftColor: getStateColor() }}>
      <span className="momentum-icon">{getStateIcon()}</span>
      <span className="momentum-message">{momentum.message}</span>
    </div>
  );
};

export default DemandMomentumIndicator;
